<template>
  <SfiNavBar
    :app-title="title"
    logo="/logo.svg"
    :page-title="route.meta.title"
    :session="session"
    :apps="session.applications"
    @sign-out="signOut"
  />

  <div class="main-app d-flex h-screen">
    <NavDrawer />

    <div class="w-100 overflow-y-auto">
      <router-view v-slot="{ Component }">
        <Transition :mode="'out-in'" :appear="true">
          <Suspense>
            <v-main class="layout pa-8 h-100">
              <component :is="Component" />
            </v-main>

            <template #fallback>
              <v-progress-circular />
            </template>
          </Suspense>
        </Transition>
      </router-view>
    </div>
  </div>
</template>

<script setup lang="ts">
import { init } from '@/lib/flags'
import { useAuth } from '@simplifi/auth'
import { useRoute } from 'vue-router'
import NavDrawer from '@/components/NavDrawer.vue'

const title = import.meta.env.VITE_APP_TITLE

const auth = useAuth()
const route = useRoute()

const { session, signOut } = auth

init()
</script>

<style>
.layout {
  display: grid;
  grid-template-rows: auto 1fr;
}
</style>
